var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { SurveyElementBase, ReactElementFactory } from "survey-react-ui";
var TranslateFromAction = /** @class */ (function (_super) {
    __extends(TranslateFromAction, _super);
    function TranslateFromAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TranslateFromAction.prototype, "item", {
        get: function () {
            return this.props.item;
        },
        enumerable: false,
        configurable: true
    });
    TranslateFromAction.prototype.getStateElement = function () {
        return this.item;
    };
    TranslateFromAction.prototype.renderElement = function () {
        var item = this.item;
        return (React.createElement("div", { className: item.data.containerCss },
            React.createElement("span", { className: item.data.additionalTitleCss }, item.data.additionalTitle),
            ReactElementFactory.Instance.createElement("sv-action-bar-item-dropdown", { item: this.item })));
    };
    return TranslateFromAction;
}(SurveyElementBase));
export { TranslateFromAction };
ReactElementFactory.Instance.registerElement("svc-translate-from-action", function (props) {
    return React.createElement(TranslateFromAction, props);
});
